import { ScheduleTourModal } from './ScheduleTourModal'

export default ScheduleTourModal
